module.exports = __webpack_public_path__ + "img/icon-android.6500f189.svg";